import styled from 'styled-components';
import { Text } from 'styles/elements/text';

const ClinicalReviewHelpText = styled(Text)`
  ${props => (props.isClinicalReviewMode ? '' : 'display: none')};
`;

export const GroupScoringText = styled(ClinicalReviewHelpText)`
  margin-left: 80px;
  ${props => props.theme.clinicalReviewStyles.groupScore};
`;

export default ClinicalReviewHelpText;
